import * as React from "react";
import { getNumberItemsWidthByNumberOfChars } from "../helpers";
export var NumberOfChildrenPlacement;
(function (NumberOfChildrenPlacement) {
    NumberOfChildrenPlacement[NumberOfChildrenPlacement["None"] = 0] = "None";
    NumberOfChildrenPlacement[NumberOfChildrenPlacement["TopRight"] = 1] = "TopRight";
    NumberOfChildrenPlacement[NumberOfChildrenPlacement["BottomRight"] = 2] = "BottomRight";
})(NumberOfChildrenPlacement || (NumberOfChildrenPlacement = {}));
var NumberOfChildren = function (_a) {
    var id = _a.id, width = _a.width, height = _a.height, textColor = _a.textColor, borderColor = _a.borderColor, bgColor = _a.bgColor, nodeTotalNodes = _a.nodeTotalNodes, isSelectedNode = _a.isSelectedNode, placement = _a.placement, style = _a.style;
    var realPlacement = isSelectedNode
        ? NumberOfChildrenPlacement.TopRight
        : placement;
    var fontSize = Number(style.fontSize);
    var itemsWidth = getNumberItemsWidthByNumberOfChars(fontSize, nodeTotalNodes.toString().length);
    var itemHeightFactor = 2;
    var itemsHeight = fontSize + itemHeightFactor;
    var strokeDasharrayTotal = itemsWidth + itemsHeight;
    if (width > itemsWidth && height > itemsHeight) {
        return (React.createElement("g", { transform: "translate(0, ".concat(realPlacement === NumberOfChildrenPlacement.BottomRight
                ? height - itemsHeight
                : 0, ")") },
            React.createElement("rect", { id: "rectNumberItems-".concat(id), x: width - itemsWidth, y: 0.5, width: itemsWidth, height: itemsHeight, fill: bgColor, stroke: borderColor, strokeDasharray: "".concat(realPlacement === NumberOfChildrenPlacement.BottomRight
                    ? itemsWidth
                    : 0, ",").concat(strokeDasharrayTotal, ",").concat(strokeDasharrayTotal) }),
            React.createElement("text", { fill: textColor, x: width - itemsWidth + itemsWidth / 2, y: itemsHeight - itemHeightFactor, textAnchor: "middle", style: {
                    fontVariant: style.fontVariant,
                    fontWeight: style.fontWeight,
                    fontSize: style.fontSize,
                    fontFamily: style.fontFamily,
                } }, nodeTotalNodes)));
    }
    return null;
};
export default NumberOfChildren;
